<template>
	<div class="notice-callout" :class="tone">
		<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
			<circle cx="12" cy="12" r="10" />
			<path d="M12 11v6M12 7.5h.01" />
		</svg>
		<div class="text">
			<b v-if="title">{{ title }}</b>
			<p><slot></slot></p>
		</div>
	</div>
</template>

<script>
// 안내 문구용 강조 박스 (기본은 파란 정보 톤)
export default {
	name: 'NoticeCallout',
	props: {
		title: {
			type: String,
			default: '',
		},
		tone: {
			type: String,
			default: 'info',
		},
	},
}
</script>

<style lang="scss" scoped>
.notice-callout {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	padding: 14px 18px;
	border: 1px solid #cfe0ff;
	border-radius: 14px;
	background: linear-gradient(90deg, #f1f7ff, #f8fbff);
	color: #1e3a8a;
	.icon {
		flex: none;
		width: 22px;
		height: 22px;
		margin-top: 1px;
		fill: #2563eb;
		stroke: #fff;
		stroke-width: 2;
		stroke-linecap: round;
		circle {
			stroke: none;
		}
	}
	.text {
		min-width: 0;
		b {
			display: block;
			margin-bottom: 2px;
			font-size: 0.95rem;
			font-weight: 800;
			color: #1d4ed8;
		}
		p {
			margin: 0;
			font-size: 0.9rem;
			font-weight: 500;
			line-height: 1.55;
			white-space: normal;
			word-break: keep-all;
		}
	}
}
</style>
